module.exports = __webpack_public_path__ + "static/media/visa.8aee341e.png";